import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import APIS from "../../constant/EndPoint";
import Card from "../Reusable/Card";
import ComboboxInput from "../Reusable/ComboboxInput";
import DeliveryChargeTable from "./DeliveryChargeTable";
//@ts-ignore
import { responsiveClassName } from "../../utils/classNames";
import MultipleSelectField from "../Reusable/MultiSelectField";
import { getKey } from "../../helpers/sessionKey";
import CargoDeliveryChargeTable from "./CargoDeliveryCharge";

const DeliveryChargeList = (props: any) => {
  const { branch, service, product, currentMerchantProfile } = props;
  const { templateID } = useParams();
  console.log("currentMerchantProfile", currentMerchantProfile?.id);
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        local_branch: branch[0]
          ? {
              id: branch[0]?.id,
              name: branch[0]?.name,
            }
          : null,
        local_service: service[0]
          ? {
              id: service[0]?.id,
              name: service[0]?.name,
            }
          : null,
        product_type: currentMerchantProfile?.default_product_type
          ? [
              {
                value: currentMerchantProfile?.default_product_type?.id,
                label: currentMerchantProfile?.default_product_type?.name,
              },
            ]
          : product[0]
          ? [
              {
                value: product[0]?.id,
                label: product[0]?.name,
              },
            ]
          : [],
      };
    },
  });
  const localServiceBranch = watch("local_branch");
  const localServiceType = watch("local_service");
  const localProductType = watch("product_type");

  const clientType = getKey("client-type");
  console.log("hero", clientType);
  return (
    <>
      <Card title={`Rate List`}>
        <div
          className={responsiveClassName(
            "w-full grid grid-cols-1 gap-x-6",
            "w-full grid grid-cols-3 gap-x-6"
          )}
        >
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"local-branch"}
            register={register("local_branch")}
            errors={errors?.local_branch}
            name={"local_branch"}
            label={"Service Branch"}
            props={{ is_active: true }}
            setValue={setValue}
            placeholder={"Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ is_active: true }}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_service}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <MultipleSelectField
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("product_type")}
            watch={watch}
            setValue={setValue}
            props={{
              is_active: true,
            }}
            url={APIS.PRODUCT_TYPE}
            value={
              currentMerchantProfile.default_product_type
                ? [
                    {
                      value: currentMerchantProfile?.default_product_type?.id,
                      label: currentMerchantProfile?.default_product_type?.name,
                    },
                  ]
                : product[0]
                ? [
                    {
                      value: product[0]?.id,
                      label: product[0]?.name,
                    },
                  ]
                : []
            }
          />
        </div>
      </Card>

      {clientType === "cargo" ? (
        <Card title={`Rate Format`}>
          {localServiceBranch &&
          localServiceType &&
          localProductType?.length !== 0 &&
          localProductType ? (
            <CargoDeliveryChargeTable
              localServiceBranch={localServiceBranch}
              localServiceType={localServiceType}
              localProductType={localProductType}
              merchantId={currentMerchantProfile?.id}
              delivery_charge_template={templateID}
            />
          ) : (
            <>
              {" "}
              <p>Please select Service Branch And Service type</p>
            </>
          )}
        </Card>
      ) : (
        <Card title={`Rate Format`}>
          {localServiceBranch &&
          localServiceType &&
          localProductType?.length !== 0 &&
          localProductType ? (
            <DeliveryChargeTable
              localServiceBranch={localServiceBranch}
              localServiceType={localServiceType}
              localProductType={localProductType}
              merchantId={null}
              delivery_charge_template={templateID}
            />
          ) : (
            <>
              {" "}
              <p>Please select Service Branch And Service type</p>
            </>
          )}
        </Card>
      )}
    </>
  );
};

export default DeliveryChargeList;
